import React from 'react';

const sizeMap = {
  xs: 'w-3.5 h-3.5 border-2',
  sm: 'w-4 h-4 border-2',
  md: 'w-6 h-6 border-[3px]',
  lg: 'w-8 h-8 border-[3px]',
  xl: 'w-12 h-12 border-4',
};

const toneMap = {
  primary: 'border-primary-200 border-t-primary-600',
  white: 'border-white/30 border-t-white',
  slate: 'border-slate-200 border-t-slate-500',
};

export const Spinner = ({ size = 'md', tone = 'primary', className = '', label }) => {
  return (
    <span role="status" className={`inline-flex items-center gap-2 ${className}`}>
      <span
        className={`inline-block rounded-full animate-spin ${sizeMap[size] || sizeMap.md} ${toneMap[tone] || toneMap.primary}`}
        aria-hidden="true"
      />
      {label && <span className="text-sm text-slate-600">{label}</span>}
    </span>
  );
};

export default Spinner;
